<template>
  <div >
    <!--<a id="TOPUp" href="#loud/monthQd" v-show="TOPUp">-->
    <!--  <el-button icon="el-icon-top" circle></el-button>-->
    <!--</a>-->
    <!--<breadcrumb :routerList="[{to:'/guanhuai',title:'抢单模块'},{title:'网络月度抢单'}]"/>-->
    <Breadtabsheader/>
    <!--            审批窗口-->
    <viewhistory :visible.sync="showhistory" v-if="showhistory" :id="instid"/>
    <div class="h-content">
      <!-- 搜素条件 -->
      <div class="h-piece">
        <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="年度">
              <el-select filterable v-model="q.year" clearable placeholder="请选择">
                <el-option
                    v-for="(item) in qyearList"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="月度" class="h-elformWrap-2" prop="username">
              <el-select filterable v-model="q.month" clearable placeholder="请选择">
                <el-option
                    v-for="(item,index) in monthList"
                    :key="item"
                    :label="item"
                    :value="item">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="区域" prop="link">
              <el-select v-model="q.area" clearable placeholder="请选择" style="width:100%">
                <el-option v-for="item in quyuList"
                           :key="item.code"
                           :label="item.name"
                           :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item class="h-elformWrap-1" label="销售人员">
              <el-select filterable v-model="q.userName" clearable placeholder="请选择">
                <el-option
                    v-for="item in users"
                    :key="item.userCode"
                    :label="item.userName"
                    :value="item.userCode">
                </el-option>
              </el-select>
            </el-form-item>
          </div>
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="状态">
              <el-select filterable v-model="q.checkStatus" clearable placeholder="请选择">
                <el-option
                    v-for="item in checkStatusLs"
                    :key="item.code"
                    :label="item.name"
                    :value="item.code">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="渠道">
              <brselect category="sales_region" :v="q.channel" v-model="q.channel" :clearable="true"
                        style="width:100%"/>
            </el-form-item>
            <el-form-item label="创建时间" prop="cdatebegin" style="width: 50%;">
              <el-date-picker
                  v-model="q.cdatebegin"
                  clearable
                  type="date"
                  value-format="yyyy-MM-dd" >
              </el-date-picker>
              <span class="w-time-to">至</span>
              <el-date-picker
                  v-model="q.cdateend"
                  clearable
                  type="date"
                  value-format="yyyy-MM-dd" >
              </el-date-picker>
            </el-form-item>





          </div>
        </el-form>
        <!-- 展开搜素 -->

        <div class="l-screenBox">
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="selectPageAll">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="createNew">
              新建月度抢单
            </el-button>
          </div>
        </div>
      </div>
      <!-- 结果展示 -->
      <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
        <el-table
            ref="multipleTable"
            @selection-change="handleSelectionChange"
            :data="dataList"
            :border="true"
            stripe
            max-height="560"
            style="width: 100%">
          <el-table-column
              type="selection"
              width="55px"></el-table-column>
          <el-table-column prop="year" label="年度" width="60px" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="month" label="月度" width="50px"></el-table-column>
<!--          <el-table-column prop="daquName" label="大区" width="65px"></el-table-column>-->
          <el-table-column prop="area" label="区域" width="65px"></el-table-column>
          <el-table-column prop="channel" label="渠道" width="150px">
            <template slot-scope="scope">
              <div align="left">{{scope.row.channel}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="userName" label="销售人员" width="90px" ></el-table-column>


          <el-table-column prop="targetAmount" sortable label="目标金额(万元)" width="150px">
            <template slot-scope="scope">
              <div align="right">{{  parseFloat(scope.row.targetAmount==null?0:scope.row.targetAmount).toFixed(2)}}</div>
            </template>
          </el-table-column>

          <el-table-column prop="loudSum" sortable label="漏斗金额(万元)" width="150px">
            <template slot-scope="scope">
              <div align="right">{{  parseFloat(scope.row.loudSum==null?0:scope.row.loudSum).toFixed(2)}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="notLoudSum" sortable label="非漏斗金额(万元)" width="165px">
            <template slot-scope="scope">
              <div align="right">{{  parseFloat(scope.row.notLoudSum==null?0:scope.row.notLoudSum).toFixed(2)}}</div>
            </template></el-table-column>
          <el-table-column prop="grabOrderSum" sortable label="未来可抢金额(万元)" width="185px">
            <template slot-scope="scope">
              <div align="right">{{  parseFloat(scope.row.grabOrderSum==null?0:scope.row.grabOrderSum).toFixed(2)}}</div>
            </template>
          </el-table-column>

          <el-table-column prop="actualAmount" sortable label="实际金额(万元)" width="150px">
            <template slot-scope="scope">
              <div align="right">{{  parseFloat(scope.row.actualAmount==null?0:scope.row.actualAmount).toFixed(2)}}</div>
            </template>
          </el-table-column>

          <el-table-column prop="checkStatus" label="状态" width="85px" >
            <template slot-scope="scope">
              <span v-if="scope.row.checkStatus == 0">正常</span>
              <span v-if="scope.row.checkStatus == 1">审批中</span>
              <span v-if="scope.row.checkStatus == 2">驳回</span>
              <span v-if="scope.row.checkStatus == 3">暂存</span>
            </template>
          </el-table-column>
          <el-table-column prop="cdate" label="提交时间" width="200px">
          </el-table-column>
          <el-table-column
              label="操作"
              fixed="right"
              width="250px">
            <template slot-scope="scope">
              <el-button
                  type="text"
                  size="small"
                  class="h-tableLink h-btn"
                  @click="genzongLiuch(scope.row)"
              >跟踪
              </el-button>
              <el-button
                  type="text"
                  size="small"
                  class="h-tableLink h-btn"
                  @click="searchDetail(scope.row)"
              >详情
              </el-button>
              <el-button
                  type="text"
                  size="small"
                  class="h-tableLink h-btn"
                  @click="updateDetail(scope.row)">编辑
              </el-button>
              <el-button
                  type="text"
                  size="small"
                  class="h-tableLink h-btn"
                  @click="deleteSingle(scope.row.id)"
              >删除
              </el-button>
              <!--              <el-button-->
              <!--                  type="text"-->
              <!--                  size="small"-->
              <!--                  class="h-tableLink h-btn"-->
              <!--                  @click="searchDetail(scope.row)"-->
              <!--              >追踪-->
              <!--              </el-button>-->
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="h-tableB h-mrt30">
        <!--  -->
        <div class="h-tableBL">
          <div class="h-tableBL">
            <el-button :disabled="this.multipleSelection.length === 0" class="h-btn h-formBtn h-bgblueQ"
                       icon="h-el-icon h-el-icon-delete" @click="deleteSelete">批量删除
            </el-button>
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel">列表导出
            </el-button>
            <!--</el-button>-->
            <!--                      <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"-->
            <!--                                 @click="exportRqExcel()">详情导出-->
            <!--                      </el-button>-->
            <!--                        <el-button v-if="!this.$store.getters.hasRole('crm_quyu')" :disabled="this.multipleSelection.length === 0" class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="approve">批量提交</el-button>-->
            <!--                      <el-button v-if="this.$store.getters.hasRole('swyl_admin') || this.$store.getters.hasRole('crm_quyu')" :disabled="this.multipleSelection.length === 0" class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import" @click="auditWin">批量审核</el-button>-->
          </div>
        </div>
        <!-- 分页 -->
        <div class="h-pagination2">
          <pagination :page="q" @query="selectPageAll"/>
        </div>
      </div>
    </div>
    <!-- 弹窗-新建月度抢单 -->
    <el-dialog :close-on-click-modal="false" @close='closeDialog' :visible.sync="newDialog" fullscreen :title="dialogTitle" center >
      <div id="loud/monthQd" ref="faultTree" class="wrap"></div>
      <el-form :model="add" :inline="true" :rules="editFormRules" label-width="120" class="demo-ruleForm">
        <table style ="border-collapse: collapse;width:100%;border-color: #EAEEF5; margin-bottom: 10px" cellspacing =0 border="1">
          <tr style="background-color: #FAFAFA; text-align: center; color:#8F9399;height:40px;">
            <td style="width: 200px">月度</td>
            <td style="width: 200px">销售人员</td>
            <td style="width: 200px">区域</td>
            <td>渠道</td>
            <td>同期金额(万元)</td>
            <td>目标金额(万元)</td>
            <td>抢单总金额(万元)</td>
            <td>未来可抢金额(万元)</td>
            <td>实际金额(万元)</td>
          </tr>
          <tr v-for="item in add.bscUserMonthlyTargetChannel" >
            <td v-show="item.idx==0?true:false" :rowspan="item.idx==0?add.bscUserMonthlyTargetChannel.length:1">
              <el-date-picker type="month" placeholder="月度" @change="selectDate" v-model="add.month" :clearable="false" value-format="yyyy-MM" style="width: 98%;padding: 5px 5px 5px 5px">
              </el-date-picker>
            </td>
            <td v-show="item.idx==0?true:false" :rowspan="item.idx==0?add.bscUserMonthlyTargetChannel.length:1">
              <el-select filterable v-model="add.userName" clearable placeholder="请选择" @change='getValue(1)' style="width: 98%;padding: 5px 5px 5px 5px">
                <el-option
                    v-for="item in users"
                    :key="item.userCode"
                    :label="item.userName"
                    :value="item.userCode">
                </el-option>
              </el-select>
            </td>
            <td v-show="item.idx==0?true:false" :rowspan="item.idx==0?add.bscUserMonthlyTargetChannel.length:1">
              <brselect category="show_area" v-model="add.area" :v="add.area" :clearable="true" @change='getValue(2)' style="width:98%;padding: 5px 5px 5px 5px"/>
            </td>
            <td style="text-align: center;padding: 5px 5px 5px 5px">{{item.channel}}</td>
            <td style="text-align: right;padding: 5px 5px 5px 5px">{{parseFloat(item.samePeriod==null?0:item.samePeriod).toFixed(2)}}</td>
            <td style="text-align: right;padding: 5px 5px 5px 5px">{{parseFloat(item.target==null?0:item.target).toFixed(2)}}</td>
            <td style="text-align: right;padding: 5px 5px 5px 5px">{{(parseFloat(item.grabOrder==null?0:item.grabOrder)+parseFloat(item.actual)).toFixed(2)}}</td>
            <td style="text-align: right;padding: 5px 5px 5px 5px">{{parseFloat(item.grabOrder==null?0:item.grabOrder).toFixed(2)}}</td>
            <td style="text-align: right;padding: 5px 5px 5px 5px">{{parseFloat(item.actual==null?0:item.actual).toFixed(2)}}</td>
          </tr>
          <tr style="background-color: #fafafa;text-align:right;">
            <td style="padding: 5px 5px 5px 5px">合计</td>
            <td></td>
            <td></td>
            <td></td>
            <td style="padding: 5px 5px 5px 5px">{{ this.sumFieldByData(add.bscUserMonthlyTargetChannel,'samePeriod').toFixed(2) }}</td>
            <td style="padding: 5px 5px 5px 5px">{{ this.sumFieldByData(add.bscUserMonthlyTargetChannel,'target').toFixed(2) }}</td>
            <td style="padding: 5px 5px 5px 5px">{{ (this.sumFieldByData(add.bscUserMonthlyTargetChannel,'grabOrder')+this.sumFieldByData(add.bscUserMonthlyTargetChannel,'actual')).toFixed(2) }}</td>
            <td style="padding: 5px 5px 5px 5px">{{ this.sumFieldByData(add.bscUserMonthlyTargetChannel,'grabOrder').toFixed(2) }}</td>
            <td style="padding: 5px 5px 5px 5px">{{ this.sumFieldByData(add.bscUserMonthlyTargetChannel,'actual').toFixed(2) }}</td>
          </tr>
        </table>
        <div style="position :absolute;z-index: 1 ;width: 100%; text-align: right ;padding-right: 68px;padding-top: 1px ">
          <el-button type="primary" icon="el-icon-edit-outline" size="medium" plain @click="dialogFormVisible = true">差因/关差计划</el-button>
        </div>

        <el-tabs v-model="activeName" type="border-card">
          <el-tab-pane label="月度汇总" name="first">
            <!--            :tree-props="{children: 'children', hasChildren: 'hasChildren'}"-->
            <el-table
                row-key="loudProductId"
                :data="add.bscUserMonthlySummary"
                border
                show-summary
                :summary-method="getSummaries"
            >
              <el-table-column
                  prop="month"
                  label="月度"
                  sortable
                  width="90" >
              </el-table-column>
              <el-table-column
                  align="right"
                  prop="agentName"
                  label="经销商"
                  width="220"
                  sortable
                  :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column
                  prop="customerChannel"
                  label="渠道"
                  width="80"
                  sortable>
                <template slot-scope="scope">
                  <dictname category="sales_region" :v="scope.row.customerChannel"/>
                </template>
              </el-table-column>
              <el-table-column
                  prop="lianqun"
                  label="链群"
                  width="80"
                  sortable>
                <template slot-scope="scope">
                  <dictname category="xsyb_lianqun" :v="scope.row.lianqun"/>
                </template>
              </el-table-column>
              <el-table-column
                  prop="contractTarget"
                  label="签约目标(万元)"
                  sortable>
                <template slot-scope="scope" >
                  <div  style=" text-align: right">{{ scope.row.contractTarget.toFixed(2) }}</div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="loudSum"
                  label="漏斗金额(万元)"
                  sortable>
                <template slot-scope="scope" >
                  <div  style=" text-align: right">{{ scope.row.loudSum.toFixed(2) }}</div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="notLoudSum"
                  label="非漏斗金额(万元)"
                  sortable>
                <template slot-scope="scope">
                  <div style=" text-align: right">{{ scope.row.notLoudSum.toFixed(2) }}</div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="grabOrder"
                  label="抢单金额(万元)"
                  sortable>
                <template slot-scope="scope">
                  <div style=" text-align: right">{{ scope.row.grabOrder.toFixed(2) }}</div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="grabOrder"
                  label="预计履约率(%)"
                  sortable>
                <template slot-scope="scope">
                  <div style=" text-align: right">{{ scope.row.contractTarget !=0 ?(scope.row.grabOrder / scope.row.contractTarget).toFixed(2):'0.00'}}</div>
                </template>
              </el-table-column>
            </el-table>
            <span name="span" style="font-size:15px;position :absolute; padding-left: 15px;padding-top: 25px">漏斗明细</span>
            <p class="p" style=" text-align: right">
              <el-button-group>
                <el-button type="primary" icon="el-icon-search" size="medium" @click="showLd">选择漏斗</el-button>
                <el-button type="warning" icon="el-icon-delete" size="medium" @click="deleteSeleteMx">删除</el-button>
              </el-button-group>
            </p>
            <el-table
                ref="multipleTableLd"
                :data="add.bscUserMonthlyLoudDetails"
                border
                default-expand-all
                style="width: 100%; margin-top: 8px"
                @selection-change="handleSelectionChangeMx">
              <el-table-column
                  type="selection"
                  width="55" fixed>
              </el-table-column>
              <el-table-column
                  prop="status"
                  label="状态"
                  width="70">
                <template slot-scope="scope">
                  <span v-if="scope.row.status == 0">正常</span>
                  <span v-if="scope.row.status == 1">审批中</span>
                  <span v-if="scope.row.status == 2">驳回</span>
                  <span v-if="scope.row.status == 3">暂存</span>
                </template>
              </el-table-column>
              <el-table-column
                  prop="funnelCode"
                  sortable
                  label="漏斗编号"
                  width="120">
              </el-table-column>
              <el-table-column
                  prop="userName"
                  label="销售人员"
                  width="77">
              </el-table-column>
              <el-table-column
                  prop="agentName"
                  label="经销商"
                  sortable
                  width="120" :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column
                  prop="partner"
                  label="合伙人"
                  width="120">
              </el-table-column>
              <el-table-column
                  prop="statusR"
                  label="节点"
                  width="100">
                <template slot-scope="scope">
                  <dictname category="xinxi_jiedian" :v="scope.row.statusR"/>
                </template>
              </el-table-column>
              <el-table-column
                  prop="estOrderDate"
                  label="预计下单日期"
                  width="110">
              </el-table-column>
              <el-table-column
                  prop="expConvDate"
                  label="预计转化日期"
                  width="110">
              </el-table-column>
              <el-table-column
                  prop="customerName"
                  label="用户单位"
                  width="120" :show-overflow-tooltip="true">
              </el-table-column>
              <el-table-column
                  prop="customerChannel"
                  label="渠道"
                  width="70">
                <template slot-scope="scope">
                  <dictname category="sales_region" :v="scope.row.customerChannel"/>
                </template>
              </el-table-column>
              <el-table-column
                  prop="lianqun"
                  label="链群"
                  width="70">
                <template slot-scope="scope">
                  <dictname category="xsyb_lianqun" :v="scope.row.lianqun"/>
                </template>
              </el-table-column>
              <el-table-column
                  prop="productType"
                  label="产品大类"
                  width="120">
              </el-table-column>
              <el-table-column
                  prop="proModel"
                  label="型号"
                  width="120">
              </el-table-column>
              <el-table-column
                  prop="num"
                  label="数量"
                  width="120">
                <template slot-scope="scope">
                  <div style=" text-align: right">{{ parseFloat(scope.row.num) || 0  }}</div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="price"
                  label="价格(万元)"
                  width="120">
                <template slot-scope="scope">
                  <div style=" text-align: right">{{ (parseFloat(scope.row.price) || 0).toFixed(2)  }}</div>
                </template>
              </el-table-column>
              <el-table-column
                  prop="totalPrice"
                  label="金额(万元)"
                  width="120">
                <template slot-scope="scope">
                  <div style=" text-align: right">{{ (parseFloat(scope.row.totalPrice) || 0).toFixed(2)  }}</div>
                </template>
              </el-table-column>
              <el-table-column
                  fixed="right"
                  label="操作"
                  width="120">
                <template slot-scope="scope">
                  <el-button
                      @click.native.prevent="deleteRowMx(scope.$index,add.bscUserMonthlyLoudDetails)"
                      type="text"
                      size="small"
                      class="h-tableLink h-btn">
                    删除
                  </el-button>
                </template>
              </el-table-column>
            </el-table>
            <span name="span" style="font-size:15px;position :absolute; padding-left: 15px;padding-top: 25px">非漏斗明细</span>
            <p class="p" style=" text-align: right">
              <el-button-group>
                <el-button type="primary" icon="el-icon-refresh" size="medium" @click="updateDataYd(-2)">更新月度汇总</el-button>
              </el-button-group>
            </p>
            <div id="app">
              <el-alert title="单位：万元" type="warning" style="margin-top: -5px;margin-bottom: 5px"></el-alert>
              <!--              <span style="position: absolute;margin-top:-7px;font-size:10px;color:#ff0000">单位：万元</span>-->
              <!--              <el-form ref="baseForm" :model="baseForm" :rules="rules">-->
              <el-table ref="table-input" highlight-current-row :data="add.bscUserMonthlyNotLoudDetails"
                        :header-cell-style='headerStyle'
                        border
                        default-expand-all
                        style="width: 100%; "
                        @row-click="selectItem">
                <el-table-column prop="" label="操作" width="115" fixed>
                  <template>
                    <el-button-group>
                      <el-button type="primary"  size="mini" @click="addLine()" title="新增">＋
                      </el-button>
                      <el-button type="primary"  size="mini" title="删除">－</el-button>
                    </el-button-group>
                  </template>
                </el-table-column>
                <el-table-column label="经销商" width="155">
                  <template slot-scope="scope">
                    <el-form-item :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.agentCode'" :rules="rules.agentCode" class="all">
                      <el-select ref="ragentCode"  v-model="scope.row.agentName" remote filterable :filter-method="showComList" clearable placeholder="请输入" :remote-method="showComList" >
                        <el-option v-for="(item) in agentList"
                                   :key="item.usercode"
                                   :label="item.customerName1"
                                   :value="item.usercode"
                                   @click.native="showComList2(item,scope.$index)">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="用户单位" width="110">
                  <template slot-scope="scope">
                    <el-form-item :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.userName'" :rules="rules.userName" class="all">
                      <el-input ref="ruserName" v-model="scope.row.userName" placeholder="请输入" clearable ></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="渠道" width="110">
                  <template slot-scope="scope">
                    <el-form-item   :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.customerChannel'" :rules="rules.customerChannel" class="all">

                      <el-select filterable v-model="scope.row.customerChannel" clearable placeholder="选择">
                        <el-option
                            v-for="item in add.bscUserMonthlyTargetChannel"
                            :key="item.channelCode"
                            :label="item.channel"
                            :value="item.channelCode">
                        </el-option>
                      </el-select>

                      <!--                      <brselect ref="rcustomerChannel" category="sales_region" :v="scope.row.customerChannel" v-model="scope.row.customerChannel" :clearable="true" style="width:100%" />-->
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="样本网" width="110">
                  <template slot-scope="scope">
                    <el-form-item :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.yangBenWang'" :rules="rules.yangBenWang" class="all">
                      <el-input ref="ryangBenWang" v-model="scope.row.yangBenWang" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" clearable></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="药品网" width="110">
                  <template slot-scope="scope">
                    <el-form-item :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.yaoPinWang'" :rules="rules.yaoPinWang" class="all">
                      <el-input ref="ryaoPinWang" v-model="scope.row.yaoPinWang" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" clearable></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="液氮罐" width="110">
                  <template slot-scope="scope">
                    <el-form-item :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.yeDanGuan'" :rules="rules.yeDanGuan" class="all">
                      <el-input ref="ryeDanGuan" v-model="scope.row.yeDanGuan" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" clearable></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="生物安全" width="110">
                  <template slot-scope="scope">
                    <el-form-item :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.shengWuAnQuan'" :rules="rules.shengWuAnQuan" class="all">
                      <el-input ref="rshengWuAnQuan" v-model="scope.row.shengWuAnQuan" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" clearable></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="培养箱" width="110">
                  <template slot-scope="scope">
                    <el-form-item :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.peiYangXiang'" :rules="rules.peiYangXiang" class="all">
                      <el-input ref="rpeiYangXiang" v-model="scope.row.peiYangXiang" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" clearable></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="离心机" width="110">
                  <template slot-scope="scope">
                    <el-form-item :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.liXinJi'" :rules="rules.liXinJi" class="all">
                      <el-input ref="rliXinJi" v-model="scope.row.liXinJi" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" clearable></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="试剂网" width="110">
                  <template slot-scope="scope">
                    <el-form-item :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.shiJiWang'" :rules="rules.shiJiWang" class="all">
                      <el-input ref="rshiJiWang" v-model="scope.row.shiJiWang" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" clearable></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="血液网" width="110">
                  <template slot-scope="scope">
                    <el-form-item :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.xueYeWang'" :rules="rules.xueYeWang" class="all">
                      <el-input ref="rxueYeWang" v-model="scope.row.xueYeWang" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" clearable></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column label="疫苗网" width="110">
                  <template slot-scope="scope">
                    <el-form-item :prop="'bscUserMonthlyNotLoudDetails.'+scope.$index+'.yiMiaoWang'" :rules="rules.yiMiaoWang" class="all">
                      <el-input ref="ryiMiaoWang" v-model="scope.row.yiMiaoWang" placeholder="请输入" oninput="value=value.replace(/[^\d.]/g, '').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3')" clearable></el-input>
                    </el-form-item>
                  </template>
                </el-table-column>
              </el-table>
              <!--              </el-form>-->
              <div class="flex-c-a margin-top-10">
                <el-button-group>
                  <el-button type="info" icon="el-icon-circle-close" @click="closeDialog()" v-show="bgb">关闭</el-button>
                  <el-button type="primary" icon="el-icon-info" @click="updateDataYd(3)" v-show="bzc">暂存</el-button>
                  <el-button type="success" icon="el-icon-check" @click="updateDataYd(-1)" v-show="btj">提交</el-button>
                </el-button-group>
                <!--                  <el-button @click="submit">暂存</el-button>-->
                <!--                  <el-button @click="submit">提交</el-button>-->
              </div>
            </div>
          </el-tab-pane>
          <el-tab-pane label="抢单预览" name="second">
            <el-table
                ref="multipleTableLd"
                :data="dataQd"
                border
                default-expand-all
                style="width: 100%; margin-top: 8px"
                @selection-change="handleSelectionChangeQd">
              <el-table-column
                  prop="version"
                  label="版本号">
              </el-table-column>
              <el-table-column
                  prop="lianqun"
                  label="链群">
                <template slot-scope="scope">
                  <dictname category="xsyb_lianqun" :v="scope.row.lianqun"/>
                </template>
              </el-table-column>
              <el-table-column
                  label="渠道">
                <template slot-scope="scope">
                  <dictname category="sales_region" :v="scope.row.customerChannel"/>
                </template>
              </el-table-column>
              <el-table-column
                  prop="oldGrabOrder"
                  label="上次抢单金额">
              </el-table-column>
              <el-table-column
                  prop="grabOrder"
                  label="本次抢单金额">
              </el-table-column>
              <el-table-column
                  prop="name"
                  label="增长率(%)">
              </el-table-column>
              <el-table-column
                  prop="name"
                  label="差因/关差计划">
              </el-table-column>
              <el-table-column
                  prop="cdate"
                  label="创建时间">
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </el-form>

    </el-dialog>
    <!--弹窗-选择漏斗-->
    <el-dialog title="newProject" :visible.sync="dialogLd" width="98%" top="5vh">
      <div class="h-piece">
        <el-form :inline="true" :model="qLd" class="demo-form-inline h-formBorder">
          <div class="h-thirdColumn w-newColumn">
            <el-form-item class="h-elformWrap-1" label="经销商">
              <el-input v-model="qLd.agentName" placeholder="输入经销商/编码" :clearable="true"></el-input>
            </el-form-item>
            <!--            <el-form-item label="漏斗状态" class="h-elformWrap-2" prop="username">-->
            <!--              <el-select filterable v-model="qLd.status" clearable placeholder="请选择">-->
            <!--                <el-option-->
            <!--                    v-for="item in checkStatusLs"-->
            <!--                    :key="item.code"-->
            <!--                    :label="item.name"-->
            <!--                    :value="item.code">-->
            <!--                </el-option>-->
            <!--              </el-select>-->
            <!--            </el-form-item>-->
            <el-form-item label="漏斗编号" class="h-elformWrap-2" prop="username">
              <el-input v-model="qLd.funnelCode" placeholder="输入漏斗编号" :clearable="true"></el-input>
            </el-form-item>
            <el-form-item label="链群" prop="area">
              <brselect category="xsyb_lianqun" :v="qLd.lianqun" v-model="qLd.lianqun" :clearable="true"
                        style="width:100%"/>
            </el-form-item>
            <el-form-item label="渠道" prop="chanel">
              <brselect category="sales_region" :v="qLd.customerChannel" v-model="qLd.customerChannel" :clearable="true"
                        style="width:100%"/>
            </el-form-item>
          </div>
        </el-form>
        <!-- 展开搜素 -->
        <div class="l-screenBox">
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="getLoudList">检索</el-button>
            <el-button class="h-btn h-formBtn h-bgwhite" @click="restLd">重置</el-button>
            <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="addMx">
              添加到明细
            </el-button>
          </div>
        </div>
      </div>
      <el-table
          row-key="loudProductId"
          ref="multipleTableLd"
          :data="dataLd"
          tooltip-effect="dark"
          style="width: 100%"
          @selection-change="handleSelectionChangeLd">
        <el-table-column
            reserve-selection
            type="selection"
            width="35">
        </el-table-column>

        <!--        <el-table-column-->
        <!--            prop="loudProductId"-->
        <!--            label="loudProductId"-->
        <!--            width="140"-->
        <!--            :show-overflow-tooltip="true">-->
        <!--        </el-table-column>-->
        <el-table-column
            prop="agentName"
            label="经销商"
            width="120"
            :show-overflow-tooltip="true">
        </el-table-column>

        <el-table-column
            prop="customerName"
            label="用户单位"
            width="120">
        </el-table-column>

        <el-table-column
            prop="customerChannel"
            label="渠道"
            width="120">
          <template slot-scope="scope">
            <dictname category="sales_region" :v="scope.row.customerChannel"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="xsyb_lianqun"
            label="链群">
          <template slot-scope="scope">
            <dictname category="xsyb_lianqun" :v="scope.row.lianqun"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="proModel"
            label="型号"
            width="120">
        </el-table-column>
        <el-table-column
            prop="num"
            label="数量"
            width="120">
        </el-table-column>
        <el-table-column
            prop="price"
            label="价格"
            width="120">
        </el-table-column>
        <el-table-column
            prop="totalPrice"
            label="金额"
            width="120">
        </el-table-column>
        <el-table-column
            prop="status"
            label="状态">
          <template slot-scope="scope">
            <span v-if="scope.row.status == 0">正常</span>
            <span v-if="scope.row.status == 1">审批中</span>
            <span v-if="scope.row.status == 2">驳回</span>
            <span v-if="scope.row.status == 3">暂存</span>
          </template>
        </el-table-column>
        <!--        <el-table-column-->
        <!--            prop="loudProductId"-->
        <!--            label="loudProductId"-->
        <!--            width="150">-->
        <!--        </el-table-column>-->
        <el-table-column
            prop="funnelCode"
            label="信息编号"
            width="120">
        </el-table-column>
        <el-table-column
            prop="salesman"
            label="销售人员"
            width="120">
        </el-table-column>
        <el-table-column
            prop="partner"
            label="合伙人"
            width="120">
        </el-table-column>
        <el-table-column
            prop="statusR"
            label="节点"
            width="120">
          <template slot-scope="scope">
            <dictname category="xinxi_jiedian" :v="scope.row.statusR"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="expOnlineDate"
            label="预计下单日期"
            width="120">
        </el-table-column>
        <el-table-column
            prop="expConvDate"
            label="预计转换日期"
            width="120">
        </el-table-column>


        <el-table-column
            prop="proLevelOne"
            label="产品大类"
            width="120">
        </el-table-column>

        <el-table-column
            prop="proType"
            label="产品类型"
            width="120">
        </el-table-column>
        <el-table-column
            prop="expectConvertDate"
            label="报单日期"
            width="120">
        </el-table-column>
        <el-table-column
            prop="cuname"
            label="填单人"
            width="120">
        </el-table-column>
        <el-table-column
            prop="areaName"
            label="区域"
            width="120">
        </el-table-column>
        <el-table-column
            prop="province"
            label="省"
            width="120">
        </el-table-column>
        <el-table-column
            prop="city"
            label="地市"
            width="120">
        </el-table-column>
        <el-table-column
            prop="probjectSorts"
            label="项目分类"
            width="120">
          <template slot-scope="scope">
            <dictname category="message_type" :v="scope.row.probjectSorts"/>
          </template>
        </el-table-column>
        <el-table-column
            prop="chanceTypeName"
            label="机会分类"
            width="120">
        </el-table-column>
        <el-table-column
            prop="projectName"
            label="项目名称"
            width="120">
        </el-table-column>
        <el-table-column
            prop="deptName"
            label="科室"
            width="120">
        </el-table-column>
        <el-table-column
            prop="chargePerson"
            label="负责人"
            width="120">
        </el-table-column>
        <el-table-column
            prop="phone"
            label="电话"
            width="120">
        </el-table-column>
        <el-table-column
            prop="scenesType"
            label="场景"
            width="120">
        </el-table-column>
        <el-table-column
            prop="proLevelTwo"
            label="产品中类"
            width="120">
        </el-table-column>
        <el-table-column
            prop="income"
            label="收入"
            width="120">
        </el-table-column>

        <el-table-column
            prop="weekInfos"
            label="周"
            width="120">
        </el-table-column>
        <el-table-column
            prop="documentaryType"
            label="跟单商类别"
            width="120">
          <template slot-scope="scope">
            <dictname category="gendanshang" :v="scope.row.documentaryType"/>
          </template>
        </el-table-column>
      </el-table>
      <div class="h-pagination2">
        <pagination :page="qLd" @query="getLoudList" />
      </div>
      <div style="margin-top: 20px">
        <!--          <el-button @click="toggleSelection([dataLd[1], dataLd[2]])">切换第二、第三行的选中状态</el-button>-->
        <!--          <el-button @click="toggleSelection()">取消选择</el-button>-->
      </div>
    </el-dialog>
    <el-dialog title="差因/关差计划" :visible.sync="dialogFormVisible">
      <el-form >
        <el-form-item label="" width="120px">
          <el-input v-model="differencePlan" autocomplete="off" height="150px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="dialogFormVisible = false">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'


export default {
  data() {
    return {
      showhistory: false,// 审批窗口
      instid:'',
      dialogTitle:'月度抢单',// 新建月度抢单
      bgb:true,
      bzc:true,
      btj:true,
      dialogFormVisible:false, // 弹窗 差因/关差计划
      TOPUp:false,
      headerStyle: {
        // 'font-weight':'500',
        // 'font-size':'20px',
        'height': '48px',
      },
      // disabled: false,
      agentList:[],// 签约经销商ls
      users:[],// 销售人员
      activeName: 'first',// tab页
      dialogLd: false,// 弹窗-选择漏斗
      dataLd: [],// 选择漏斗
      dataQd:[],// 抢单预览
      qLd: {
        pageNo: 1,
        pageSize: 10,
        total: 0,
        type: 1,
        agentName:'',// 经销商
        status:'',// 状态
        funnelCode:'',//漏斗编码
        lianqun:'',//链群
        customerChannel:'',// 渠道
        loudProductId:""// 已选中ids
      },// 选择漏斗查询条件
      baseForm: {
        demoList: [
          {
            birthday: '2010-05-02',
            name: '',
            age: '',
            address: ''
          }
        ]
      },// 非漏斗明细
      index: 0,
      rules: {
        name: [
          {
            required: true,
            message: "请输入经销商",
            trigger: "blur"
          }
        ],
        age: [
          {required: true, message: "请输入", trigger: "blur"}
        ],
        birthday: [
          {required: true, message: "请选择", trigger: "change"}
        ],
        address: [
          {required: true, message: "请输入", trigger: "blur"}
        ],
      },
      q: {
        checkStatus: "",//
        userCode: "",
        userName: "",
        approvalStatus: '',
        area: "",
        year: "",
        month: "",
        dates: "",
        channel: "",
        cdatebegin:"",//开始日期
        cdateend:"",//结束日期
        pageNo: 1,
        pageSize: 10,
        total: 0,
        type: 1
      },
      // 列表
      dataList:[],
      bscUserMonthlyNotLoudDetails2:[],// 非漏斗明细 => 漏斗明细 数据格式
      differencePlan:'',// 关差计划
      add2:{},
      // 主表
      add: {
        year: '',// 年度
        month: '',//月度
        userCode: '',//销售人员
        userName: '',//销售人员名称
        area: '',//区域
        bscUserMonthlySummary: [],// 月度汇总
        bscUserMonthlyTargetChannel: [// 渠道目标
          {
            channel: '',//渠道
            channelCode: '',//渠道编码
            samePeriod:0,//同期
            target: 0,//目标
            actual:0,// 实际
            grabOrder:0,//抢单金额
          }
        ],// 渠道目标
        bscUserMonthlyLoudDetails: [],// 明细-漏斗
        bscUserMonthlyNotLoudDetails: [{
          pid: '',//pid
          agentName: '',//经销商名称
          agentCode: '',//经销商编码
          userCode: '',//销售人员编码
          userName: '',//销售人员名称
          customerChannel: '',//渠道
          yangBenWang: 0,//样本网
          yaoPinWang: 0,//药品网
          yeDanGuan: 0,//液氮罐
          shengWuAnQuan: 0,//生物安全
          peiYangXiang: 0,//培养箱
          liXinJi: 0,//离心机
          shiJiWang: 0,//试剂网
          yiMiaoWang: 0,//疫苗网
          xueYeWang: 0,//血液网
          yunYanWang: 0,//云眼网
        }],// 非漏斗明细
      },
      checkStatusLs: [
        {"code": "0", "name": "正常"},
        {"code": "1", "name": "审批中"},
        {"code": "2", "name": "驳回"}, // 驳回的重新提交，传2
        {"code": "3", "name": "暂存"}],
      qyearList: [],
      // tableData: [],
      quyuList: [],
      qudaoList: [],
      linkList: [],// 链群
      //表格
      multipleSelection: [],
      multipleSelectionLd: [],// 漏斗选中
      multipleSelectionMx: [],// 明细选中
      multipleSelectionQd: [],
      // 展开折叠筛选
      isScreen: false,
      uploaddownexcelflag: false,
      newDialog: false,
      updatelog: false,
      detailedDialog: false,
      auditlog: false,
      switchNewTab: 1,
      productCodeList: [],
      findByNameList: [],
      showFormProductList: [],
      optionList: [],
      links: [],
      templateItems: [],
      switchBtnTab: 0,    //默认选中第一个
      title: '选项1',
      titleArr: ['选项1', '选项2'],
      planList: [],
      loudouList: [],
      rebateSeriesList: [],
      templateReachTargetList: [],
      monthList: ["01", "02", "03", "04", "05", "06", "07", "08", "09", "10", "11", "12"],
      editFormRules: {
        username: [{required: true, message: '请输入必填项', trigger: 'blur'}],
        link: [{required: true, message: '请输入必填项', trigger: 'blur'}],
        chanel: [{required: true, message: '请输入必填项', trigger: 'blur'}],
        product: [{required: true, message: '请输入必填项', trigger: 'blur'}],
        custMonth: [{required: true, message: '请输入必填项', trigger: 'blur'}],
        grabBill: [{required: true, message: '请输入必填项', trigger: 'blur'}],
      },
      qyFlag: false,
    }
  },
  methods: {

    genzongLiuch(r) {
      console.log(r);
      this.instid = r.instid;
      this.showhistory = true;
    },
    // 合计数组某个字段
    sumFieldByData(data,field){
      return data.reduce(function (total, currentValue, currentIndex, arr){
        return currentValue[field] ? (parseFloat(total)  + parseFloat(currentValue[field])) : total;
      }, 0);
    },
    // 批量删除明细
    deleteSeleteMx(){
      // 删除漏斗明细选中行
      this.multipleSelectionMx.forEach(element => {
        this.$refs.multipleTableLd.toggleRowSelection(element);// 并删除选中（因为这里有分页选择）
        this.add.bscUserMonthlyLoudDetails.splice(this.add.bscUserMonthlyLoudDetails.indexOf(element), 1);
      });

      // rows.splice(rows[index], 1);// 更新表格list
      // this.add.bscUserMonthlyLoudDetails = rows;// 更新到数据
      // 漏斗明细合并到月度汇总
      let bscUserMonthlySummary_ = this.arrayGroup(this.add.bscUserMonthlyLoudDetails.concat(this.bscUserMonthlyNotLoudDetails2));
      bscUserMonthlySummary_.sort((a, b) => a.agentName.localeCompare(b.agentName));// 经销商名称排序
      this.add.bscUserMonthlySummary=bscUserMonthlySummary_;
      this.$set(this.add, this.add.bscUserMonthlySummary,bscUserMonthlySummary_);
      this.updateMain();// 更新主体
      // this.$message({
      //   showClose: true,
      //   message: '月度汇总，漏斗明细已更新',
      //   type: 'success'
      // });
    },
    // 更新主体 （包含 ：月度汇总合计）
    updateMain(){
      let this_ = this;
      let idx = 0;
      let bscUserMonthlyTargetChannel_ = this.add.bscUserMonthlyTargetChannel.map(function (curr) {
        return {
          idx:idx++,
          grabOrder :
              this_.add.bscUserMonthlySummary.filter(t=> t.customerChannel==curr.channelCode).reduce(function (total, currentValue, currentIndex, arr){
                return currentValue['customerChannel'] ? (total + currentValue['grabOrder']) : total;
              }, 0).toFixed(2),
          channel: curr.channel,//渠道
          channelCode: curr.channelCode,//渠道编码
          target: curr.target,//目标
          actual:curr.actual,// 实际
          samePeriod: curr.samePeriod,//去年同期
        }
      });
      this.add.bscUserMonthlyTargetChannel = bscUserMonthlyTargetChannel_;
      // 月度汇总合计
      this.add.contractTargetSum = this.sumFieldByData(this.add.bscUserMonthlySummary,'contractTarget');// 签约目标
      this.add.loudSum = this.sumFieldByData(this.add.bscUserMonthlySummary,'loudSum');// 漏斗金额（万元）
      this.add.notLoudSum = this.sumFieldByData(this.add.bscUserMonthlySummary,'notLoudSum');// 非漏斗金额（万元）
      this.add.grabOrderSum = this.sumFieldByData(this.add.bscUserMonthlySummary,'grabOrder');// 抢单金额（万元）
    },
    showComList2(obj,index){
      this.add.bscUserMonthlyNotLoudDetails[index].agentCode=obj.usercode;
      this.add.bscUserMonthlyNotLoudDetails[index].agentName=obj.customerName1;
      console.log(index);
    },
    //签约经销商
    showComList(value) {
      ss.netApi.selectByUserNameLoud(value).then(res => {
        // console.log(res)
        this.agentList = res.obj.slice(0,100);
        // this.loudmain.agentCode = res.obj[0].usercode
      })
    },
    // 漏斗弹窗
    showLd(){
      this.dialogLd = true;
      this.restLd();
      this.getLoudList();// 获取漏斗信息
    },
    // 获取漏斗信息
    getLoudList(){
      console.log(100);
      this.qLd.month= this.add.month;
      this.qLd.monthUser= this.add.userCode;
      this.qLd.loudProductId='';
      if(this.add.bscUserMonthlyLoudDetails!=null)
        this.qLd.loudProductId= this.add.bscUserMonthlyLoudDetails.map(item=>{return item.loudProductId}).join(",");
      let ts = this;
      ss.netApi.getLoudList(this.qLd).then(res => {
        this.dataLd = res.records;
        this.qLd.total= res.total || 0;
        // this.formInline.total = rd.total || 0;
      })
    },
    // 获取 渠道目标
    // getTargetChannel(row){//
    //   let query= {"targetDate": this.add.month, "userCode": this.add.userCode, "area": this.add.area};
    //   ss.netApi.getTargetChannel(query).then(res => {
    //     let _arr = []
    //     let idx = 0;
    //     res.obj.map((item, index) => {
    //       _arr.push(Object.assign({},item,{idx: idx}));
    //       idx++;
    //     });
    //     // _arr.push(_arr[1]);
    //     // _arr.push(_arr[1]);
    //     // _arr = _arr.slice(0,1)
    //     // console.log(1001,_arr);
    //     // console.log(123,_arr);
    //     this.add.bscUserMonthlyTargetChannel=_arr;
    //     this.$set(this.add, this.add.bscUserMonthlyTargetChannel,_arr);
    //   })
    // },
    // 获取 销售人员
    getUserList(){//
      ss.netApi.getUserList().then(res => {
        this.users=res.obj;
      })
    },
    // 选择漏斗分页
    // selectPageAllLd() {//
    //   ss.netApi.selectPageCustom(this.qLd).then(res => {
    //     console.log(res.records)
    //     this.dataLd = res.records
    //     this.qLd.total = res.total
    //   })
    // },
    // 月度抢单 列表
    selectPageAll() {//selectPageCustom
      ss.netApi.selectMonthlyList(this.q).then(res => {
        // console.log(res.obj)
        this.dataList = res.records;
        this.q.total = res.total
      })
    },
    // 非漏斗明细
    // 选中某一行修改或移除
    selectItem(row, column, event) {
      this.selectedFundRow = row
      if (event.target.innerText == "－") {
        // if(event.target.innerHTML.indexOf('el-icon-minus')!=-1){
        this.removeFundBtn(this.selectedFundRow)
      }
    },
    // 删除指定行
    removeFundBtn(params) {
      this.add.bscUserMonthlyNotLoudDetails = this.add.bscUserMonthlyNotLoudDetails.filter((ele) => {
        var flag = false
        // 如果不一致，则保留该行
        for (const key in params) {
          if (ele[key] != params[key]) {
            flag = true
            break
          }
        }
        return flag
      })
      // 如果全部删除后没有可以点击的一行了，需要加一行空行
      if (!this.add.bscUserMonthlyNotLoudDetails.length) {
        this.addLine()
      }
    },
    // 非漏斗明细更新到月度汇总 save -2 正常
    updateDataYd(save){
      console.log("savesavesave".save);
      let lines = this.add.bscUserMonthlyNotLoudDetails;// 非漏斗明细
      let this_ = this;
      // 非漏斗明细空一行提交时处理联动数据
      if (lines.length==1 && lines[0].yangBenWang==0 && lines[0].yaoPinWang==0 && lines[0].yeDanGuan==0 && lines[0].shengWuAnQuan==0 && lines[0].peiYangXiang==0 && lines[0].liXinJi==0 && lines[0].shiJiWang==0 && lines[0].xueYeWang==0 && lines[0].yiMiaoWang==0 &&  lines[0].agentCode=='' && lines[0].userName=='' && lines[0].customerChannel=='') { // 数据都被删
        this_.add.bscUserMonthlySummary = this_.arrayGroup(this_.add.bscUserMonthlyLoudDetails);// 更新月度汇总
        this_.bscUserMonthlyNotLoudDetails2=[];
        this_.updateMain();// 更新主体
        if(save!=-2){ // 点击了保存、暂存时；避免漏更新先更新上面 => 月度汇总
          this_.saveData(save);
        }
      } else if(this.yz(lines)) {// 验证
        let querys= [];// 查询集合 (也是要汇总的条数)
        lines.forEach(item => {
          let lianquns = [];// 9个链群集合
          lianquns.push({code : 'X02', name : '样本网', val : parseFloat(item.yangBenWang)});// 样本网
          lianquns.push({code : 'X01', name : '药品网', val : parseFloat(item.yaoPinWang)});// 药品网
          lianquns.push({code : 'X04', name : '液氮罐', val : parseFloat(item.yeDanGuan)});// 液氮罐
          lianquns.push({code : 'X08', name : '生物安全', val : parseFloat(item.shengWuAnQuan)});// 生物安全
          lianquns.push({code : 'X09', name : '培养箱', val : parseFloat(item.peiYangXiang)});// 培养箱
          lianquns.push({code : 'X10', name : '离心机', val : parseFloat(item.liXinJi)});// 离心机
          lianquns.push({code : 'X07', name : '试剂网', val : parseFloat(item.shiJiWang)});// 试剂网
          lianquns.push({code : 'X05', name : '血液网', val : parseFloat(item.xueYeWang)});// 血液网
          lianquns.push({code : 'X06', name : '疫苗网', val : parseFloat(item.yiMiaoWang)});// 疫苗网
          lianquns.map(itemLq => {
            let totalPriceF_ = 0;// 非漏斗金额
            if(itemLq.val != 0) {
              querys.push({
                month: this_.add.month,
                agentCode: item.agentCode,// 经销商编码
                agentName: '',// 经销商名称 后台取
                contractTarget:0,// 签约目标 后台取
                userUnit:item.userName,// 用户单位
                lianqun: itemLq.code,// 链群编码
                lianqunName: itemLq.name,// 链群名称
                channel:item.customerChannel,// 渠道编码
                notLoudSum:itemLq.val,// 非漏斗金额
              });
            }
          });
        });
        // 后台 => 换取签约目标
        ss.netApi.getNotLoudTarget(querys).then(res => {
          // 签约目标数据 => 漏斗明细 数据格式
          this_.bscUserMonthlyNotLoudDetails2 = res.obj.map(item => {
            return {
              pid: '',
              agentName: item.agentName,// 经销商名称
              agentCode: item.agentCode,// 经销商编码
              expConvDate: item.month+'-'+new Date().getDate(),// 月度
              week: '',// 周
              lianqun: item.lianqun,// 链群
              customerChannel: item.channel,// 渠道
              contractTarget: item.contractTarget,// 签约目标
              totalPrice: 0,// 漏斗金额（万元）
              totalPriceF: parseFloat(item.notLoudSum) ,// 非漏斗金额（万元）
              // totalPrice: item.totalPrice,//抢单金额（万元）
            }
          });
          // 转换字段名称: 用漏斗明细 数据格式 => arrayGroup(转换月度汇总格式)
          let bscUserMonthlyLoudDetails_ = this_.add.bscUserMonthlyLoudDetails==null?[]:this_.add.bscUserMonthlyLoudDetails;
          let bscUserMonthlySummary_ = this_.arrayGroup(bscUserMonthlyLoudDetails_.concat(this_.bscUserMonthlyNotLoudDetails2));
          bscUserMonthlySummary_.sort((a, b) => a.agentName.localeCompare(b.agentName));// 经销商名称排序
          this_.add.bscUserMonthlySummary=bscUserMonthlySummary_;
          this_.$set(this_.add, this_.add.bscUserMonthlySummary,bscUserMonthlySummary_);
          this_.updateMain();// 更新主体
          // 新建 编辑界面提示
          if(this_.btj) {
            // this_.$message({
            //   showClose: true,
            //   message: '月度汇总，非漏斗明细已更新',
            //   type: 'success'
            // });
          }
          if(save!=-2){ // 点击了保存、暂存时；避免漏更新先更新上面 => 月度汇总
            this_.saveData(save);
          }
        });
      }
    },
    // 增加一个空行, 用于录入或显示第一行
    addLine() {
      const newLine = {
        pid: '',//pid
        agentName: '',//经销商名称
        agentCode: '',//经销商编码
        userCode: '',//销售人员编码
        userName: '',//销售人员名称
        customerChannel: '',//渠道
        yangBenWang: 0,//样本网
        yaoPinWang: 0,//药品网
        yeDanGuan: 0,//液氮罐
        shengWuAnQuan: 0,//生物安全
        peiYangXiang: 0,//培养箱
        liXinJi: 0,//离心机
        shiJiWang: 0,//试剂网
        yiMiaoWang: 0,//疫苗网
        xueYeWang: 0,//血液网
        yunYanWang: 0,//云眼网
      };
      // this.index++;
      let lines = this.add.bscUserMonthlyNotLoudDetails;
      if(this.yz(lines)) {// 验证
        lines.push(newLine);
      }
    },
    // 验证 bscUserMonthlyNotLoudDetails
    yz(datas){
      let f = true;
      let this_ = this;
      let mes = '';
      datas.slice(0,datas.length).map(function (data) {
        if(data.agentCode == ''){
          mes = '请输入经销商';
          f = false
        } else if(data.customerChannel == ''){
          mes = '请输入渠道';
          f = false
        } else if(data.yangBenWang === ''){
          mes = '请输入样本网';
          f = false
        } else if(data.yaoPinWang === ''){
          mes = '请输入药品网';
          f = false
        } else if(data.yeDanGuan === ''){
          mes = '请输入液氮罐';
          f = false
        } else if(data.shengWuAnQuan === ''){
          mes = '请输入生物安全';
          f = false
        } else if(data.peiYangXiang === ''){
          mes = '请输入培养箱';
          f = false
        } else if(data.liXinJi === ''){
          mes = '请输入离心机';
          f = false
        } else if(data.shiJiWang === ''){
          mes = '请输入试剂网';
          f = false
        } else if(data.xueYeWang === ''){
          mes = '请输入血液网';
          f = false
        } else if(data.yiMiaoWang === ''){
          mes = '请输入疫苗网';
          // this_.$refs.ryiMiaoWang.focus();
          f = false
        }
      });
      if(mes!='')
        this_.$message({
          message: mes,
          type: 'warning'
        });
      return f;
    },
    // 详情
    searchDetail(row){
      this.add2 = JSON.parse(JSON.stringify(row));//深度拷贝
      this.cleanAdd(this.add2,'update');
      this.add2.month=this.add2.year+'-'+this.add2.month;// 拼接月度
      // 获取抢单预览
      let this_ = this;
      let qdprms = { id: this_.add2.id, version: this_.add2.version};
      ss.netApi.monthlyListByHistory(qdprms).then(res => {
        if(res.f) {
          this_.dataQd = res.obj;
        }
      });
      this.dialogTitle="月度抢单-详情";
      this.bzc=false;
      this.btj=false;
    },
    // 编辑
    updateDetail(row){
      this.dialogTitle="月度抢单-编辑";
      this.add2 = JSON.parse(JSON.stringify(row));//深度拷贝
      this.cleanAdd(this.add2,'update');
      this.add2.month=this.add2.year+'-'+this.add2.month;// 拼接月度
      // 获取抢单预览
      let this_ = this;
      let qdprms = { id: this_.add2.id, version: this_.add2.version};
      ss.netApi.monthlyListByHistory(qdprms).then(res => {
        if(res.f) {
          this_.dataQd = res.obj;
        }
      });
      this.bzc=true;
      this.btj=true;
      // this.getTargetChannel(row);// 获取渠道目标
      // this.add=row;
      // this.updateMain();// 更新主体 ,处理渠道目标，合计抢单金额
      // this.add.bscUserMonthlyTargetChannel
      // this.$set(this.add, this.add.bscUserMonthlyTargetChannel,this.add.bscUserMonthlyTargetChannel);
      // console.log(row);
    },
    // 删除
    deleteSingle(id){
      let data ={
        ids:id
      }
      this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ss.netApi.deleteMonthly(data).then(res => {
          console.log(res)
          if(res.f == true ){
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.selectPageAll()
          }else{
            this.$message.error(res.msg);
          }
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },

    // 空数据提交验证
    notNull(add){
      let f = true;
      if(add.bscUserMonthlyLoudDetails.length==0 &&
          add.bscUserMonthlyNotLoudDetails[0].yangBenWang==0 && add.bscUserMonthlyNotLoudDetails[0].yaoPinWang==0 && add.bscUserMonthlyNotLoudDetails[0].yeDanGuan==0 && add.bscUserMonthlyNotLoudDetails[0].shengWuAnQuan==0 && add.bscUserMonthlyNotLoudDetails[0].peiYangXiang==0 && add.bscUserMonthlyNotLoudDetails[0].liXinJi==0 && add.bscUserMonthlyNotLoudDetails[0].shiJiWang==0 && add.bscUserMonthlyNotLoudDetails[0].xueYeWang==0 && add.bscUserMonthlyNotLoudDetails[0].yiMiaoWang==0){
        f=false;
      }
      return f;
    },
    // 暂存、提交、编辑
    saveData(exeNum){
      let this_ = this;
      // this_.updateDataYd(exeNum);// 提交时先更新到月度汇总
      console.log('exeNum',this.add2.checkStatus);
      this.add2.checkStatus = exeNum;
      if(this_.add2.id!=null){// 编辑
        this_.add2.checkStatus = exeNum==3 ? 3 : this_.add2.checkStatus;// 后台传存储状态
        if(this_.notNull(this_.add2)){
          ss.netApi.updateMonthly(this.add2).then(res => {
            console.log(1008, res);
            if (res.f) {
              this_.selectPageAll();
              this_.newDialog = false;
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: '请录入漏斗数据',
            type: 'info'
          });
        }
      } else {
        this_.add.checkStatus = exeNum==3 ? 3 : this_.add.checkStatus;// 后台传存储状态
        if(this_.notNull(this_.add)){
          // 提交
          ss.netApi.insertMonthly(this.add).then(res => {
            console.log(res);
            if (res.f) {
              this_.selectPageAll();
              this_.newDialog = false;
            }
          });
        } else {
          this.$message({
            showClose: true,
            message: '请录入漏斗数据',
            type: 'info'
          });
        }
      }
    },
    // 提交
    // submit() {
    //   this.$refs.add.validate((valid) => {
    //     if (valid) {
    //       this.$confirm("您确定【提交】？", "提示", {
    //         confirmButtonText: "确定",
    //         cancelButtonText: "取消",
    //         type: "warning"
    //       }).then(() => {
    //         console.log("校验通过")
    //       })
    //     }
    //   })
    // },
    // 删除明细
    deleteRowMx(index, rows) {
      this.$refs.multipleTableLd.toggleRowSelection(rows[index]);// 并删除选中（因为这里有分页选择）
      rows.splice(rows[index], 1);// 更新表格list
      this.add.bscUserMonthlyLoudDetails = rows;// 更新到数据

      // 漏斗明细合并到月度汇总
      let bscUserMonthlySummary_ = this.arrayGroup(this.add.bscUserMonthlyLoudDetails.concat(this.bscUserMonthlyNotLoudDetails2));
      bscUserMonthlySummary_.sort((a, b) => a.agentName.localeCompare(b.agentName));// 经销商名称排序
      this.add.bscUserMonthlySummary=bscUserMonthlySummary_;
      this.$set(this.add, this.add.bscUserMonthlySummary,bscUserMonthlySummary_);

      this.updateMain();// 更新主体
      // this.$message({
      //   showClose: true,
      //   message: '月度汇总，漏斗明细已更新',
      //   type: 'success'
      // });
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTableLd.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTableLd.clearSelection();
      }
    },
    // 添加到明细 漏斗
    addMx(){
      // this.multipleSelectionLd.map(item =>{return {...item, userName:item.salesman,estOrderDate:item.expOnlineDate}});
      // 字段转换
      this.multipleSelectionLd.forEach((node) => {
        node.userName = node.salesman,
            node.estOrderDate = node.expOnlineDate,
            node.productType = node.proLevelOne
      });
      this.add.bscUserMonthlyLoudDetails = this.add.bscUserMonthlyLoudDetails.concat(this.multipleSelectionLd);// 选中的添加到明细
      // this.add.bscUserMonthlyLoudDetails = this.multipleSelectionLd;// 选中的添加到明细
      this.dialogLd = false;// 选择漏斗 关闭
      // 漏斗明细合并到月度汇总
      let bscUserMonthlySummary_ = this.arrayGroup(this.add.bscUserMonthlyLoudDetails.concat(this.bscUserMonthlyNotLoudDetails2));
      bscUserMonthlySummary_.sort((a, b) => a.agentName.localeCompare(b.agentName));// 经销商名称排序
      this.add.bscUserMonthlySummary=bscUserMonthlySummary_;
      this.$set(this.add, this.add.bscUserMonthlySummary,bscUserMonthlySummary_);
      this.updateMain();// 更新主体

      this.$refs.multipleTableLd.clearSelection();
      // this.$message({
      //   showClose: true,
      //   message: '月度汇总，漏斗明细已更新',
      //   type: 'success'
      // });
    },
    // 并转换字段名称;数组分组统计; 漏斗
    arrayGroup(inData){
      let fthis = this;
      // 转换字段名称
      let newnewArr =  inData.map(item => {
        let totalPriceF_ = item.totalPriceF == null ? 0 : item.totalPriceF;
        let contractTarget_ =item.contractTarget == null ? 0 : item.contractTarget;
        let totalPrice_ =item.totalPrice == null ? 0 : item.totalPrice;
        return {
          pid: '',
          agentName: item.agentName,//经销商名称
          agentCode: item.agentCode,//经销商编码
          month: fthis.add.month,//item.expConvDate.substring(0,item.expConvDate.lastIndexOf('-')),//月度
          week: '',//周
          lianqun: item.lianqun,//链群
          customerChannel: item.customerChannel,//渠道
          contractTarget: contractTarget_,//fthis.add.bscUserMonthlyTargetChannel.find(t => t.channelCode==item.customerChannel).target,//签约目标
          loudSum: totalPrice_,//漏斗金额（万元）
          notLoudSum: totalPriceF_,//非漏斗金额（万元）
          grabOrder: totalPrice_+totalPriceF_,//抢单金额（万元）
        }
      });
      // 分组统计
      let ydGroup = newnewArr.reduce((total, cur, index) => {
        let hasValue = total.findIndex(current => {
          // current.code === cur.code && current.t === cur.t
          return current.agentCode === cur.agentCode &&
              current.month === cur.month &&
              current.lianqun === cur.lianqun &&
              current.customerChannel === cur.customerChannel
        })
        hasValue === -1 && total.push(cur)
        hasValue !== -1 && (total[hasValue].loudSum = total[hasValue].loudSum + cur.loudSum)
        hasValue !== -1 && (total[hasValue].notLoudSum = total[hasValue].notLoudSum + cur.notLoudSum)
        hasValue !== -1 && (total[hasValue].grabOrder = total[hasValue].loudSum + total[hasValue].notLoudSum)
        return total
      }, []);
      return ydGroup;
    },
    // 合计列
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = '合计';
          return;
        } else if (index == 1 || index == 2 || index == 3 || index == 8) {
          sums[index] = '-';
          return;
        }
        const values = data.map(item => Number(item[column.property]));
        if (!values.every(value => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          // console.log(10011,sums[index]);
          //
          sums[index] = sums[index]!=0?sums[index].toFixed(2):sums[index];// 保留2位小数
          sums[index] += '';//' 万元'
          sums[index] = parseFloat(sums[index]).toFixed(2);
        } else {
          sums[index] = '-';
        }
      });

      return sums;
    },
    // 新增月度抢单 弹窗
    createNew() {
      this.$confirm('请在每月1日下午5:30之前完成抢单，超过预定时间，当月工资减半，季度不统算。', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.dialogTitle="月度抢单-新建";
        this.bzc=true;
        this.btj=true;
        this.cleanAdd(this.add,'add');
      }).catch(() => {
      });
      // this.getTargetChannel();// 获取渠道目标
    },
    // closeNew(){
    //   this.TOPUp = false; // 返回顶部
    // },
    // 选择日期
    selectDate(date){
      let this_ = this;
      let query= {"targetDate": date, "userCode": this_.add.userCode, "area": this_.add.area};
      // 获取渠道目标
      ss.netApi.getTargetChannel(query).then(res => {
        let _arr = []
        let idx = 0;
        res.obj.map((item, index) => {
          _arr.push(Object.assign({}, item, {idx: idx}));
          idx++;
        });
        this_.add.bscUserMonthlyTargetChannel = _arr;
        this_.$set(this_.add, this_.add.bscUserMonthlyTargetChannel, _arr);
      });
    },
    // 初始化弹窗，清除数据
    cleanAdd(row,exeType){
      this.TOPUp = true; // 返回顶部
      this.newDialog = true;
      this.add= {
        year: '',// 年度
        month: '',//月度
        userCode: '',//销售人员
        userName: '',//销售人员名称
        area: '',//区域
        bscUserMonthlySummary: [],// 月度汇总
        bscUserMonthlyTargetChannel: [// 渠道目标
          {
            channel: '',//渠道
            channelCode: '',//渠道编码
            target: 0,//目标
            actual:0,// 实际
            grabOrder:0,//抢单金额
          }
        ],// 渠道目标
        bscUserMonthlyLoudDetails: [],// 明细-漏斗
        bscUserMonthlyNotLoudDetails: [{
          pid: '',//pid
          agentName: '',//经销商名称
          agentCode: '',//经销商编码
          userCode: '',//销售人员编码
          userName: '',//销售人员名称
          customerChannel: '',//渠道
          yangBenWang: 0,//样本网
          yaoPinWang: 0,//药品网
          yeDanGuan: 0,//液氮罐
          shengWuAnQuan: 0,//生物安全
          peiYangXiang: 0,//培养箱
          liXinJi: 0,//离心机
          shiJiWang: 0,//试剂网
          yiMiaoWang: 0,//疫苗网
          xueYeWang: 0,//血液网
          yunYanWang: 0,//云眼网
        }],// 非漏斗明细
      },
          // this.$refs.multipleTableLd.toggleRowSelection();// 并删除选中（因为这里有分页选择）
          this.add.month = new Date().getFullYear()+"-"+(new Date().getMonth()+1<10?"0"+(new Date().getMonth()+1):(new Date().getMonth()+1));// 年月
      this.add.userName=this.$store.getters.user.username;// 销售人员
      this.add.userCode=this.$store.getters.user.usercode;// 销售人员
      try {
        let userid = localStorage.getItem("userId");
        userid = userid.trim();
        let areacd = this.users.find(t=> t.userCode==userid).areaCode;// 区域
        this.add.area = areacd;
      }catch (e){
        // this.add.area="BEI_JING";// 没取到区域默认一个
      }
      let this_ = this;
      // 用编辑行数据传参查询渠道目标
      if(exeType == 'update'){
        this.add.month=row.year+"-"+row.month;
        this.add.userCode=row.userCode;
        let user = this.users.find(t=>t.area == row.area);
        this.add.area = user.areaCode;
      }
      let query= {"targetDate": this.add.month, "userCode": this.add.userCode, "area": this.add.area};
      // 获取渠道目标
      ss.netApi.getTargetChannel(query).then(res => {
        let _arr = []
        let idx = 0;
        res.obj.map((item, index) => {
          _arr.push(Object.assign({},item,{idx: idx}));
          idx++;
        });
        this_.add.bscUserMonthlyTargetChannel=_arr;
        this_.$set(this_.add, this_.add.bscUserMonthlyTargetChannel,_arr);
        // this.updateMain();// 更新主体
        if(exeType=='update'){
          // 编辑 详情用dynamicActual
          row.bscUserMonthlyTargetChannel = row.bscUserMonthlyTargetChannel.map(function (curr) {
            return {
              ...curr,
              actual: curr.dynamicActual
            }
          });
          this_.add = row;
          this_.updateDataYd(-2);// 非漏斗明细 to 月度汇总
          this_.updateMain();// 更新主体

        }
      });
    },
    //关闭弹框的事件
    closeDialog() {
      this.TOPUp = false; // 返回顶部
      this.newDialog = false;
      this.add2=[];
      this.bscUserMonthlyNotLoudDetails2=[];
      this.add ={
        year: '',// 年度
        month: '',//月度
        userCode: '',//销售人员
        userName: '',//销售人员名称
        area: '',//区域
        bscUserMonthlySummary: [],// 月度汇总
        bscUserMonthlyTargetChannel: [// 渠道目标
          {
            channel: '',//渠道
            channelCode: '',//渠道编码
            target: 0,//目标
            actual:0,// 实际
            grabOrder:0,//抢单金额
          }
        ],// 渠道目标
        bscUserMonthlyLoudDetails: [],// 明细-漏斗
        bscUserMonthlyNotLoudDetails: [{
          pid: '',//pid
          agentName: '',//经销商名称
          agentCode: '',//经销商编码
          userCode: '',//销售人员编码
          userName: '',//销售人员名称
          customerChannel: '',//渠道
          yangBenWang: 0,//样本网
          yaoPinWang: 0,//药品网
          yeDanGuan: 0,//液氮罐
          shengWuAnQuan: 0,//生物安全
          peiYangXiang: 0,//培养箱
          liXinJi: 0,//离心机
          shiJiWang: 0,//试剂网
          yiMiaoWang: 0,//疫苗网
          xueYeWang: 0,//血液网
          yunYanWang: 0,//云眼网
        }],// 非漏斗明细
      }
    },
    restLd(){
      this.qLd= {
        pageNo: 1,
        pageSize: 10,
        total: 0,
        type: 1,
        agentName:'',// 经销商
        status:'',// 状态
        funnelCode:'',//漏斗编码
        lianqun:'',//链群
        customerChannel:'',// 渠道
        loudProductId:""// 已选中ids
      }
    },
    // 列表筛选条件 重置
    rest(){
      var pageSize=this.q.pageSize;
      var pageNo=this.q.pageNo;
      var total=this.q.total;
      this.q= {
        area:"",
        usercode:"",
        username:"",
        year: "",
        cdatebegin:"",//开始日期
        cdateend:"",//结束日期
        pageSize: pageSize,
        pageNo: pageNo,
        total:total,
        type:1
      }
    },
    // 批量删除
    deleteSelete(){
      var data = this.multipleSelection.map(item => item.id).join()
      console.log(data)
      this.deleteSingle(data)
    },

    getValue(item){
      if (item == 1){
        let newUser = this.users.find(t=> t.userCode==this.add.userName);// 获取选中 销售人员
        this.add.userCode = newUser.userCode;
        this.add.userName = newUser.userName;
        this.add.area = newUser.areaCode;// 更新区域
      }else if (item == 2) {
      }
      let this_ = this;
      let query= {"targetDate": this_.add.month, "userCode": this_.add.userCode, "area": this_.add.area};
      // 获取渠道目标
      this_.add.bscUserMonthlyTargetChannel = null;
      ss.netApi.getTargetChannel(query).then(res => {
        let _arr = []
        let idx = 0;
        res.obj.map((item, index) => {
          _arr.push(Object.assign({}, item, {idx: idx}));
          idx++;
        });
        this_.add.bscUserMonthlyTargetChannel = _arr;
        this_.$set(this_.add, this_.add.bscUserMonthlyTargetChannel, _arr);
      });
    },
    //
    uploaddownexcelflagbtn() {
      this.uploaddownexcelflag = true;
    },
    //明细导出
    exportExcel() {
      updownfile.down("/api/swyl/v1/month/bscUserMonthlyOrderGrab/newDownloadExcel",this.q,"post",'data');
    },
    exit(){
      this.newDialog= false,
          this.editDialog = false
    },
    close(){
      this.detailedDialog= false
    },
    exitColse(){
      console.log("sfdsd")
      this.detailedDialog = false
    },

    //表格
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    handleSelectionChangeLd(val) {
      this.multipleSelectionLd = val;
    },
    handleSelectionChangeMx(val) {
      this.multipleSelectionMx = val;
    },
    handleSelectionChangeQd(val) {
      this.multipleSelectionQd = val;
    },
    getQuyuList() {
      ss.Dictservice.listbycategory("show_area").then(rd => {
        this.quyuList = rd;
      })
    },
    getQudaoList() {
      ss.Dictservice.listbycategory("sales_region").then(rd => {
        this.qudaoList = rd;
      })
    },
    getLinkList() {
      ss.Dictservice.listbycategory("xsyb_lianqun").then(rd => {
        this.linkList = rd;
      })
    },
  },
  created() {
    var date = new Date();
    this.q.year = date.getFullYear();
    this.getUserList();// 获取销售人员
    //this.getNowTime()
    this.selectPageAll();// 月度抢单列表
    // this.selectPageAllLd();// 选择漏斗
    // this.showplanList()
    // //this.shouLoudou()
    // this.showRebateSeries()
    // this.showTemplateReachTarget()
    this.getQuyuList();
    this.getQudaoList();
    this.getLinkList();
    for (var i = 2021; i < new Date().getFullYear() + 2; i++) {
      this.qyearList.push(i);
    }
    if (this.$store.getters.hasRole('crm_quyu')) {
      this.qyFlag = true;
    }
  },
  components: {
    uploaddownexcel,
  },
}
</script>
<style scoped>
/deep/ .h-formbLine .el-form-item__label {
  width: 105px;
}

/deep/ .h-formbLine .el-form-item__content {
  width: 150px;
}

.addPro {
  width: 100%;
  /* display:flex; */
}

.addPro .el-form-item {
  width: 31% !important;
}

.addPro .el-form-item /deep/ .el-form-item__content {
  width: 280px;
}

.addPro .el-dialog__body {
  padding: 0 0;
}

.addPro .el-form-item /deep/ .el-input__inner {
  height: 37px;
  line-height: 37px;
}

/* 切换 */
.card-namber {
  border-bottom: #dbdbdb 2px solid;
}

.card-namber span {
  padding: 0 10px;
}

.buttonActive {
  color: #1b78e6;
  border-bottom: #1b78e6 2px solid;
  font-size: 14px;
  font-weight: 600
}



.projectCon {
  display: flex;
  padding: 5px 0;
  margin: 0 10px 5px 10px;
  color: #1b78e6;
}

.projectCon p {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  border-bottom: #1b78e6 1px dashed;
  padding: 5px 0;
  margin: 0 auto 10px auto;
  color: #1b78e6;
}

</style>

<style lang='less' scoped>
.clolos1 { //增加按钮样式
  width: 13px;
  height: 30px;
  background: #29affb;
  line-height: 30px;
  padding: 0 10px;
  border-radius: 15px;
  color: #fff;
  position: absolute;
  margin-left: 65.35%;
  margin-top: 8.48%;
  z-index: 1;
}

.clolos2 {
  width: 13px;
  height: 30px;
  background: #29affb;
  line-height: 30px;
  padding: 0 10px;
  border-radius: 15px;
  color: #fff;
  position: absolute;
  margin-left: 65%;
  margin-top: 7%;
}

.clolos3 { //删除按钮样式
  width: 13px;
  height: 30px;
  background: red;
  line-height: 30px;
  padding: 0 10px;
  border-radius: 15px;
  color: #fff;
  position: absolute;
  margin-left: calc(100% + 40px);
  margin-top: 10%;
}

.add_pdf {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  width: 80%;
  position: relative;
  margin-top: 3%;
}

.basicinformation {
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
  width: 80%;
  position: relative;
}

.h-bgblueQ1 {
  background: #c61c1c;
}

.p {
  border-left: 6px solid #00C2FF;
  background-color: #E8F8FF;
  margin-top: 15px;
  margin-bottom: 10px;
  height: 38px;
  line-height: 38px;
  padding-left: 10px;
  font-size: 15px;
  //font-weight:800;
}

.tag-group span {
  border-radius: 5px;
  margin: -8px 5px 15px 5px;
}

// 非漏斗明细
.all {
  //width: 100%;
  height: 20px
}

.flex-c-a {
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.margin-top-10 {
  margin-top: 10px;
}

.base-form.el-form-item__content {
  margin-left: 10px;
}

.add-btn {
  color: #4077F4;
}

.delete-btn {
  color: #f56c6c;
}

#fldcz {
  height: 99px;
}
/deep/.el-table .el-table__footer-wrapper .cell{
  text-align: right;
}
#TOPUp{
  position: fixed;
  right: 20px;
  bottom: 5px;
  width: 40px;
  height: 40px;
  z-index: 99999999;
  //box-shadow: 0px 0px 4px 4px #ecefef;
  //border-radius: 600px;
}



</style>
